import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

// If the page is loaded from a different origin than the baked-in backend URL
// (e.g. a custom domain pointed at this deployment), fall back to a same-origin
// `/api` base. Emergent's ingress proxies `/api/*` to the backend on every
// hostname, so this turns cross-origin third-party-cookie auth into safe
// first-party auth without rebuilding the bundle.
function resolveApiBase() {
  if (typeof window === "undefined") {
    return `${BACKEND_URL}/api`;
  }
  if (!BACKEND_URL) return "/api";
  try {
    const baked = new URL(BACKEND_URL);
    if (baked.origin === window.location.origin) {
      return `${BACKEND_URL}/api`;
    }
    // Different origin — use same-origin relative path
    return "/api";
  } catch {
    return "/api";
  }
}

export const API = resolveApiBase();

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Er is iets misgegaan. Probeer het opnieuw.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
